<!--
 * @Author: 仙道
 * @Date: 2022-10-28 19:30:07
 * @LastEditTime: 2022-10-28 20:40:31
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/vue/modules/DevModelTabs.vue
-->
<template>
  <a-tabs>
    <a-tab-pane key="baoy" tab="保养标准"></a-tab-pane>
    <a-tab-pane key="bpbj" tab="备品备件">2</a-tab-pane>
    <a-tab-pane key="doc" tab="手册资料">3</a-tab-pane>
  </a-tabs>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DevModelTabs',
  components: {},
  props: {
    modelId: {
      type: String,
      default: ''
    }
  },
  // 定义属性
  data() {
    return {}
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters([''])
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>
